<template>
  <div class="list-group list-group-flush training-files-list">
    <button
      v-for="(file, index) in files"
      :key="file.id"
      type="button"
      class="list-group-item list-group-item-action d-flex align-items-center px-3"
      :class="{ active: selectedId === file.id }"
      @click="$emit('select', file)"
    >
      <span v-if="numbered" class="training-files-list-number mr-2">
        {{ index + 1 }}.
      </span>
      <i :class="fileIcon(file)" class="mr-2"></i>
      <span class="flex-grow-1 text-left text-break">{{ file.name }}</span>
      <el-tooltip
        v-if="file.completed_at"
        :content="
          $t('TRAININGS.SEEN_ON', {
            date: $timeZoneDateFormat(file.completed_at, 'LL'),
          })
        "
        placement="top"
      >
        <i class="fa fa-check-circle ml-2 training-files-list-seen"></i>
      </el-tooltip>
      <small
        v-else-if="watchedPercent(file) > 0"
        class="ml-2 text-muted text-nowrap training-files-list-percent"
      >
        {{ watchedPercent(file) }} %
      </small>
    </button>
  </div>
</template>

<script>
export default {
  name: "training-files-list",

  props: {
    files: {
      type: Array,
      default: () => [],
    },
    selectedId: {
      type: Number,
      default: null,
    },
    numbered: {
      type: Boolean,
      default: false,
      description: "Show the step number (training path)",
    },
  },

  methods: {
    // Share of a video to watch to the end already seen.
    watchedPercent(file) {
      if (!file.must_watch || !file.duration_seconds) {
        return 0;
      }
      return Math.min(
        100,
        Math.round((file.watched_seconds / file.duration_seconds) * 100)
      );
    },

    fileIcon(file) {
      const extension = file.file_extension?.toLowerCase();
      if (this.$isFileVideo(file)) {
        return "fa fa-play-circle text-primary";
      }
      if (extension === "pdf") {
        return "fa fa-file-pdf text-danger";
      }
      if (["doc", "docx"].includes(extension)) {
        return "fa fa-file-word text-info";
      }
      if (this.$isFileImage(file)) {
        return "fa fa-image text-success";
      }
      return "fa fa-file text-muted";
    },
  },
};
</script>

<style lang="scss" scoped>
.training-files-list .list-group-item.active .training-files-list-seen,
.training-files-list .list-group-item.active .training-files-list-percent,
.training-files-list .list-group-item.active i {
  color: #fff !important;
}
.training-files-list-seen {
  color: #2dce89;
}
.training-files-list-number {
  min-width: 1.5rem;
  font-weight: 600;
}
</style>
